import React from "react";
import { Button } from "./ui/button";
import { LogOut } from "lucide-react";

export function Header({ isLoggedIn, onLogout }) {
  return (
    <header className="bg-slate-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto py-5 flex items-center justify-center gap-4">
        <img
          src="https://stiueg.org.br/wp-content/uploads/2023/07/Logo-Stiueg.png"
          alt="Stiueg Logo"
          className="h-10"
        />
        <h1 className="text-xl sm:text-md font-bold">
          Portal STIUEG - Acordo Judicial
        </h1>
        {isLoggedIn && (
          <Button
            onClick={onLogout}
            className="bg-red-600 hover:bg-red-700 text-white flex items-center gap-2"
          >
            <LogOut className="w-4 h-4" />
            Sair
          </Button>
        )}
      </div>
    </header>
  );
}
